module.exports = __webpack_public_path__ + "static/img/icon6-7.76d03a1f.png";